<template>
    <v-container fluid>
        <v-row
          justify="center"
          style="position: relative;z-index: 111"
          :class="$vuetify.display.xs ? 'mx-n7' : 'mx-auto'"
        >
            <products-pad-button
              id="Cuisine-HBM"
              :isActive="isActive[0]"
              :title="$vuetify.locale.t('$vuetify.kitchen')"
              @loadModel="$emit('loadModel', $event)"
              @buttonClicked="changeClass($event)"
            />
            <products-pad-button
              id="Meuble-salon"
              :isActive="isActive[1]"
              :title="$vuetify.locale.t('$vuetify.furniture')"
              @loadModel="$emit('loadModel', $event)"
              @buttonClicked="changeClass($event)"
            />
            <products-pad-button
              id="Meuble-placard"
              :isActive="isActive[2]"
              :title="$vuetify.locale.t('$vuetify.storage')"
              @loadModel="$emit('loadModel', $event)"
              @buttonClicked="changeClass($event)"

            />
            <products-pad-button
              id="Meuble-sdb"
              :isActive="isActive[3]"
              :title="$vuetify.locale.t('$vuetify.bathroom')" 
              @loadModel="$emit('loadModel', $event)"
              @buttonClicked="changeClass($event)"

            />
        </v-row>
    </v-container>
</template>
<script>
import { useLocale } from 'vuetify'
import ProductsPadButton from './ProductsPadButton.vue'
    export default {
        setup () {
          const { t } = useLocale()
          return {
            t
          }
        },
        name: 'ProductsPad',
        components: {
            ProductsPadButton
        },
        emits: ['loadModel'],
        data () {
            return {
                isActive: [true, false, false, false],
                buttonsId: ['Cuisine-HBM', 'Meuble-salon', 'Meuble-placard', 'Meuble-sdb']
            }
        },
        
        methods: {
            changeClass (id) {
                let newIsActive = []
                for(let i=0; i < this.buttonsId.length; i++) {
                    (id === this.buttonsId[i]) ? newIsActive.push(true) : newIsActive.push(false)
                }
                this.isActive = newIsActive
            }
        }
    }
</script>
